// import { eye, outlineuser } from '@assets/icons'
// import Status from '@components/status'
// import Table from '@components/table'
// import theme from '@utils/theme'
// import React, { Fragment } from 'react'
// import MatchroomDetails from '../detail-modal'
// import { useModal } from '@context/ModalContext'

// const PlayerCreated = () => {
//   const { showModal } = useModal()
//   const columns = [
//     { title: 'Match ID', key: 'matchId' },
//     { title: 'Created By', key: 'createdBy' },
//     { title: 'Matchroom Name', key: 'matchroomName' },
//     { title: 'Game Name', key: 'gameName' },
//     { title: 'No. of Players', key: 'numberOfPlayers' },
//     { title: 'Match Type', key: 'matchType' },
//     { title: 'Game Time', key: 'gameTime' },
//     {
//       title: 'Status',
//       key: 'status',
//       render: (item: any) => (
//         <Status
//           item={item}
//           statuses={['On going', 'Completed', 'Not Started']}
//         />
//       ),
//     },
//   ]
//   const childColumns = [
//     {
//       title: 'SN',
//       key: 'sn',
//       render: (_: any, index: number) => index + 1,
//     },
//     { title: 'Player Name', key: 'playerName' },
//     { title: 'Gamer Tag', key: 'gamerTag' },
//     {
//       title: 'Status',
//       key: 'status',
//       render: (item: any) => <Status item={item} statuses={['Joined']} />,
//     },
//   ]
//   const data = [
//     {
//       matchId: 'M001',
//       createdBy: 'Achyut Thapa',
//       matchroomName: 'Room Alpha',
//       gameName: 'Free Fire',
//       numberOfPlayers: 4,
//       matchType: 'Solo',
//       gameTime: '2025-07-07 14:00',
//       status: 'On going',
//       players: [
//         {
//           playerName: 'Sita Sharma',
//           gamerTag: 'sita_ff23',
//           status: 'Joined',
//         },
//         {
//           playerName: 'Ram Bahadur',
//           gamerTag: 'ram_bh34',
//           status: 'Joined',
//         },
//       ],
//     },
//     {
//       matchId: 'M002',
//       createdBy: 'Sita Sharma',
//       matchroomName: 'Room Beta',
//       gameName: 'PUBG',
//       numberOfPlayers: 2,
//       matchType: 'Duo',
//       gameTime: '2025-07-08 16:30',
//       status: 'Not Started',
//       players: [
//         {
//           playerName: 'Achyut Thapa',
//           gamerTag: 'achyut_pubg',
//           status: 'Joined',
//         },
//       ],
//     },
//     {
//       matchId: 'M003',
//       createdBy: 'Ram Bahadur',
//       matchroomName: 'Room Gamma',
//       gameName: 'pubg',
//       numberOfPlayers: 3,
//       matchType: 'Squad',
//       gameTime: '2025-07-06 18:00',
//       status: 'Completed',
//       players: [
//         {
//           playerName: 'Laxmi Rai',
//           gamerTag: 'laxmi_cod',
//           status: 'Joined',
//         },
//         {
//           playerName: 'Nabin KC',
//           gamerTag: 'nabin_kc',
//           status: 'Joined',
//         },
//       ],
//     },
//   ]
//   return (
//     <Fragment>
//       <Table
//         text="Player Created Matchrooms"
//         icon={outlineuser}
//         data={data}
//         columns={columns}
//         searchKeys={['matchId']}
//         actions={[
//           {
//             icon: eye,
//             key: 'view',
//             onClick: (item) => {
//               showModal(<MatchroomDetails item={item} />)
//             },
//           },
//         ]}
//         expandedRowRender={(row) => (
//           <Table
//             hasSearchbar={false}
//             data={row.players}
//             columns={childColumns}
//             borderRadius={0}
//             headerBgColor={theme.colors.borderColor}
//           />
//         )}
//       />
//     </Fragment>
//   )
// }

// export default PlayerCreated

import PlayerCreatedMatches from '@commons/matches/player-created'

const PlayerCreated = () => {
  return <PlayerCreatedMatches />
}

export default PlayerCreated
